import { render, staticRenderFns } from "./message-footer.vue?vue&type=template&id=1c9feb35&"
import script from "./message-footer.vue?vue&type=script&lang=js&"
export * from "./message-footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports